module.exports = __webpack_public_path__ + "static/media/luma-banner-25.7ed36134.png";